import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseDto } from '../models/response.dto';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export abstract class API {
  // Simple version toggle - you can implement your own logic
  private readonly baseUrl = environment.baseUrlOdd;

  constructor(protected http: HttpClient) {}

  protected get<T>(url: string): Observable<T> {
    return this.http.get<ResponseDto<T>>(`${this.baseUrl}/${url}`).pipe(
      map((response) => {
        if (response.success) {
          return response.result;
        } else {
          throw new Error(response.message);
        }
      }),
      catchError((error) => {
        console.error('HTTP Error: ', error);
        return throwError(() => error);
      })
    );
  }

  protected post<ResponseType, BodyType>(
    url: string,
    body: BodyType
  ): Observable<ResponseType> {
    return this.http
      .post<ResponseDto<ResponseType>>(`${this.baseUrl}/${url}`, body)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.result;
          } else {
            throw new Error(response.message);
          }
        }),
        catchError((error) => {
          console.error('HTTP Error: ', error);
          return throwError(() => error);
        })
      );
  }

  protected put<ResponseType, BodyType>(
    url: string,
    body: BodyType
  ): Observable<ResponseType> {
    return this.http
      .put<ResponseDto<ResponseType>>(`${this.baseUrl}/${url}`, body)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.result;
          } else {
            throw new Error(response.message);
          }
        }),
        catchError((error) => {
          console.error('HTTP Error: ', error);
          return throwError(() => error);
        })
      );
  }

  protected delete<T>(url: string): Observable<T> {
    return this.http.delete<ResponseDto<T>>(`${this.baseUrl}/${url}`).pipe(
      map((response) => {
        if (response.success) {
          return response.result;
        } else {
          throw new Error(response.message);
        }
      }),
      catchError((error) => {
        console.error('HTTP Error: ', error);
        return throwError(() => error);
      })
    );
  }
}
